import type { CompatibilityResult } from '@streamlain/field-types';

import {
  type ResponseFieldInfo,
  type TargetColumnInfo,
} from '../../sidebar/utils/auto-match-fields';
import type {
  CapabilityRequirement,
  ComponentCapability,
} from '../../types/capability-schema';

export interface DbColumnInfo {
  id: string;
  name: string;
  type: string;
}

export interface CapabilityBindingResult {
  role: string;
  columnId: string | null;
  compatibility: CompatibilityResult;
  source: 'override' | 'auto' | 'unresolved';
  alternatives: Array<{
    columnId: string;
    columnName: string;
    compatibility: CompatibilityResult;
  }>;
}

export interface BindingResolverInput {
  capabilities: ComponentCapability[];
  columns: DbColumnInfo[];
  overrides?: Record<string, string>;
}

export interface BindingResolverOutput {
  bindings: Record<string, CapabilityBindingResult>;
  missingRequired: string[];
}

export function requirementToTargetColumn(
  cap: ComponentCapability,
  req: CapabilityRequirement
): TargetColumnInfo {
  if (req.acceptedTypes.length === 0) {
    throw new Error(
      `CapabilityRequirement ${cap.role}:${req.field} has empty acceptedTypes`
    );
  }
  return {
    id: `${cap.role}:${req.field}`,
    name: req.field,
    type: req.acceptedTypes[0],
  };
}

export function dbColumnToResponseField(col: DbColumnInfo): ResponseFieldInfo {
  return {
    path: col.id,
    type: col.type,
    displayName: col.name,
  };
}
